module.exports = __webpack_public_path__ + "img/circle.ebd9341b.svg";